import React, { Component, Fragment } from "react";
import { Col, Container, Row } from "reactstrap";

class Index extends Component {
  public render() {
    return (
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Col className="mb-5 mb-xl-0" xl="8">
              <h1>Metsec Product Selector</h1>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default Index;
